import { render, staticRenderFns } from "./PayrollResourcePrintable.vue?vue&type=template&id=98d920b8&"
import script from "./PayrollResourcePrintable.vue?vue&type=script&lang=js&"
export * from "./PayrollResourcePrintable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports